export { default } from './qr-code';
